module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aMx7N"))).then(() => parcelRequire('hEqeo'));